import { FunctionComponent } from 'react'
import { ContainerProps } from './types'
import useStyles from './styles'

export const Container: FunctionComponent<ContainerProps> = ({
  children,
  css,
  ...rest
}) => {
  const styles = useStyles()
  return (
    <div css={[styles.container, css]} {...rest}>
      {children}
    </div>
  )
}
